import EventsBase from './EventsBase';
import {eventsconfig} from '../config/eventsconfig';

export {EventsBase};


export const findEvents = (service:string) => {
  const events:any = eventsconfig;
  return events[service];
}

export const getEvents = (service:string) => {
  const events:any = eventsconfig;
  return events[service];
}
